import React, { useState, useEffect, useRef } from "react";
import get from "lodash/get";
import { connect } from "react-redux";

import { Header } from ".";
import { string, bool, object } from "prop-types";
import TopAd from "../molecules/TopAd";
import { useDeviceWidth } from "../utils/react-utils";

import "./header.m.css";

const HeaderWrapper = ({
  domainSlug,
  publisherAttributes,
  pageType,
  hideTopAd = false,
  isVideoStory,
  isVerticalMenubar
}) => {
  const [stickyHeader, setStickyHeader] = useState(false);
  const [domainClassName, setDomainClassName] = useState("");
  const [domainConfig, setDomainConfig] = useState({});
  const isMounted = useRef(null);
  const [isMobileTopAd, setMobileTopAd] = useState(true);

  const [isDesktop, setIsDesktop] = useState(false);

  const verticalMenuActiveStyle = isVerticalMenubar ? "vertical-menu-active" : "";

  useDeviceWidth(setIsDesktop);

  useEffect(() => {
    if (domainSlug) {
      setDomainClassName(`${domainSlug}-section-header`);
    }
  }, [domainSlug]);

  useEffect(() => {
    // to avoid memory leaks
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 350 && isMounted.current) {
        setStickyHeader(true);
      } else {
        isMounted.current && setStickyHeader(false);
      }
    });
  }, []);

  useEffect(() => {
    const kishoralo = {
      domainSlug: "kishoralo",
      showWeatherAndTime: false,
      showEdition: false,
      className: "kishoralo-section-header",
      navClassName: "kishoralo-nav",
      stickyClassName: "sticky-kishoralo-section-header",
      navBorderBottom: true
    };
    const bondhushava = {
      domainSlug: "bondhushava",
      showWeatherAndTime: false,
      showEdition: false,
      className: "bondhushava-section-header",
      navClassName: "bondhushava-nav",
      stickyClassName: "sticky-bondhushava-section-header",
      navBorderBottom: false
    };

    const protichinta = {
      domainSlug: "protichinta",
      showWeatherAndTime: false,
      showEdition: false,
      className: "protichinta-section-header",
      navClassName: "protichinta-nav",
      stickyClassName: "sticky-protichinta-section-header",
      navBorderBottom: false
    };

    const bigganchinta = {
      domainSlug: "biggan-chinta",
      showWeatherAndTime: false,
      showEdition: false,
      className: "bigganchinta-section-header",
      navBorderBottom: true
    };

    const trust = {
      domainSlug: "trust",
      showWeatherAndTime: false,
      showEdition: false,
      className: "trust-section-header",
      navClassName: "trust-nav",
      navBorderBottom: false
    };

    const nagorik = {
      domainSlug: "nagorik-sangbad",
      showWeatherAndTime: false,
      showEdition: false,
      className: "nagorik-section-header",
      navClassName: "nagorik-nav",
      navBorderBottom: false
    };

    if (domainSlug) {
      switch (domainSlug) {
        case "kishoralo":
          return setDomainConfig(kishoralo);
        case "protichinta":
          return setDomainConfig(protichinta);
        case "biggan-chinta":
          return setDomainConfig(bigganchinta);
        case "bigganchinta":
          return setDomainConfig(bigganchinta);
        case "trust":
          return setDomainConfig(trust);
        case "bondhushava":
          return setDomainConfig(bondhushava);
        case "nagorik-sangbad":
          return setDomainConfig(nagorik);
        default:
          break;
      }
    }
  }, [domainSlug]);

  useEffect(() => {
    if (isVerticalMenubar && global.deviceWidth < 876) {
      setMobileTopAd(false);
    } else setMobileTopAd(true);
  }, [isVerticalMenubar]);

  const stickyStyleName = () => {
    if (stickyHeader) {
      return "full-width-sticky";
    } else {
      return "header-border-bottom";
    }
  };

  // check this before pushing
  const getAdTypes = () => {
    if (publisherAttributes.lang === "en") {
      switch (pageType) {
        case "home-page":
          return "EnPalo_HP_970x90_T1";
        default:
          return "EnPalo_ROS_728x90_T1";
      }
    } else {
      switch (pageType) {
        case "home-page":
          return "Home_728x90_T1";
        default:
          return "News_728x90_T1";
      }
    }
  };

  const pageTypeHeader = () => {
    if (isDesktop) {
      if (
        pageType === "home-page" ||
        pageType === "story-page" ||
        pageType === "section-page" ||
        pageType === "collection-page"
      ) {
        return "non-sticky-header-container";
      } else {
        return "sticky-header-container";
      }
    } else {
      return "sticky-header-container";
    }
  };

  return (
    <React.Fragment>
      <div styleName="top-ad-wrapper">{!hideTopAd && isMobileTopAd && <TopAd adtype={getAdTypes()} />}</div>
      <header id="header" styleName={`${stickyStyleName()} ${pageTypeHeader()} ${verticalMenuActiveStyle}`}>
        <Header
          stickyHeader={stickyHeader}
          domainConfig={domainConfig}
          domainSlug={domainSlug}
          className={domainClassName}
          isVideoStory={isVideoStory}
          isDesktop={isDesktop}
        />
      </header>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    domainSlug: get(state, ["qt", "domainSlug"], ""),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    pageType: get(state, ["qt", "pageType"]),
    isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false)
  };
};

HeaderWrapper.propTypes = {
  obsPoint: string,
  domainSlug: string,
  isVideoStory: bool,
  publisherAttributes: object,
  pageType: string,
  hideTopAd: bool,
  isVerticalMenubar: bool
};

export default connect(mapStateToProps)(HeaderWrapper);
